import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class BasicInfoHeaderService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web de obtener datos basicos de un usuario
   * Autor: Diego Diaz
   * @param customerAccountId identificador de la cuenta
   * @return Mensaje de confirmación de la validación
   */
  getPendingTickets(customerAccountId) {
    return this.serviceCallUtilsService.callSecuredPostWebService(
      constants.ENDPOINT_TICKET_GET_BY_DOCUMENT_STATES, 
      { "customerAccountId": customerAccountId, state: [constants.STATE_ASIGNED, constants.STATE_PROGRESS, constants.STATE_ONHOLD] }
    );
  }

   /**
   * Description: Método que llama el servicio web que elimina o destruye la sesión
   * Autor: Diego Diaz
   * @param documentId documento del usuario
   * @param token token de seguridad del usuario
   * @return Listado de beneficios 
   * @ModifiedBy Ciro -  Se trae el ajuste del componente logout a este
   */
  logOut(documentId, token) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_LOGOUT, {"documentId":documentId, "token":token});
  }
}
